import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { FsCgu, FsCguStatus } from '@fairandsmart/types';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FsAngularComponentsModule } from '@fairandsmart/angular/components';

export interface CguDialogData {
  readOnly?: boolean;
  cgu: FsCgu;
}

@Component({
    selector: 'fs-cgu-dialog',
    templateUrl: './cgu-dialog.component.html',
    imports: [CdkScrollable, MatDialogContent, FsAngularComponentsModule]
})
export class CguDialogComponent {
  dialogRef = inject<MatDialogRef<CguDialogComponent>>(MatDialogRef);

  data = inject<CguDialogData>(MAT_DIALOG_DATA);

  close(result: FsCguStatus) {
    this.dialogRef.close(result);
  }
}
